export enum PASSWORD_RULES {
    LowercaseLetter = "lowercase letter",
    MinimumCharacters = "minimum characters",
    NewPasswordsMustMatch = "new passwords must match",
    NewAndCurrentPasswordsMustNotMatch = "new and current passwords must not match",
    Number = "number",
    SpecialSymbol = "special symbol",
    UppercaseLetter = "uppercase letter"
}
